<template>
  <div class="w100 footer">
    <div class="w120 mc font-16 flex-box" style="text-align: center">
      <!--<div class="mr20 flex-1" :class="{'tx-r':!copyrightInfo}">版权信息：{{copyrightInfo || '桂ICP备14004231'}}</div>-->
      <div class="mr20 flex-1">版权信息：{{copyrightInfo || '桂ICP备14004231'}}</div>
      <!--<div class="ml20 flex-1" v-if="!copyrightInfo">官方网址：<a class="font-16" href="http://zs.hcnu.edu.cn/">http://zs.hcnu.edu.cn/</a></div>-->
    </div>
  </div>
</template>

<script>
import { getLoginConfig } from "@/api/login";
export default {
  name: "Footer",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
        copyrightInfo:''
    };
  },
  computed: {},
  created() {},
  mounted() {
    getLoginConfig().then(res => {
      if (res.data.success) {
        this.copyrightInfo = res.data.data.copyright_info;
      }
    });
  },
  destroyed() {},
  methods: {},
  watch: {},
  filters: {},
};
</script>

<style scoped>
.footer {
  /* margin: 20px 0 0 0; */
  height: 70px;
  line-height: 70px;
  background: #024a84;
}
</style>
